export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://44.211.41.114";

export const SIGNUP = "/users/signup";
export const SIGNIN = "/users";
export const OTP_VERIFICATION = "/users/otp_verification";
export const RESEND_OTP = "/users/resend_otp";
export const FORGOTPASSWORD = "/users/forgot_password";
export const RESETPASSWORD = "/users/reset_password";
export const USERINFO = "/users";
export const PAYMENTMETHOD = "/payment_methods";
export const PRICEPLAN = "/price_plans";
export const ADD_CARD = "/payment_methods";
export const LOGOUT = "/users";
export const ORDERS = "/orders";
export const CHATS = "/chats";
export const NOTIFICATIONS = "/notifications";
export const UPDATEPASSWORD = "/users/update_password";
export const ORDERSQUOTES = "/orders/quotes";
export const ACCEPTPRICEQUECTION = "/accept_price_quotation";
export const TRANSACTIOS = "/transactions";
export const SOCIALLOGIN = "/users/social_login";
export const ADMIN_LOGIN = "/admin/login";
export const ADMIN_CUSTOMER = "/admin/customers";
export const ADMIN_DRIVERS = "/admin/drivers";
export const ADMIN_DISPACHES = "/admin/dispatches";
export const ADMIN_JOBHISTORY = "/admin/job_histories";
export const ADMIN_CHAT = "/admin/chats";
export const ADMIN_AGENTS = "/admin/agents";
export const ADMIN_ACCOUNTINGS = "/admin/accountings";
export const ADMIN_LOGOUT = "/admin/logout";
